import { forwardRef, memo, type ReactNode } from 'react';
import { ChevronDown } from 'lucide-react';
import { KawaiiButton } from '../button'; // Assuming button is separate
import { kawaiiBaseStyles, kawaiiFocusStyles, kawaiiHoverGlowStyles } from '../kawaiiStyles';
import { twMerge } from 'tailwind-merge';

interface KawaiiSelectButtonProps {
  value?: string | number;
  isOpen: boolean;
  placeholder?: ReactNode;
  selectedOptionLabel?: ReactNode;
  onClick: () => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLButtonElement>) => void;
  className?: string;
}

// The button that triggers the magic! ✨
const KawaiiSelectButtonComponent = forwardRef<HTMLButtonElement, KawaiiSelectButtonProps>(
  ({ isOpen, placeholder, selectedOptionLabel, onClick, onKeyDown, className }, ref) => {
    return (
      <div className="relative w-full group">
        <KawaiiButton
          ref={ref}
          type="button"
          onClick={onClick}
          variant="secondary"
          onKeyDown={onKeyDown}
          className={twMerge(
            kawaiiBaseStyles,
            kawaiiFocusStyles,
            kawaiiHoverGlowStyles,
            `
            w-full justify-between rounded-3xl 
            border border-pink-200 z-[9999]
            bg-white 
            text-gray-700 dark:text-gray-300
            focus:border-pink-400 dark:focus:border-pink-500
            ${!selectedOptionLabel ? 'text-gray-400 dark:text-gray-600' : ''}
          `,
            className,
          )}
          aria-haspopup="listbox"
          aria-expanded={isOpen}
        >
          <span className="flex-1 text-left truncate">{selectedOptionLabel ?? placeholder}</span>
          <ChevronDown
            className={`w-4 h-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
            aria-hidden="true" // It's decorative, ze~!
          />
        </KawaiiButton>
      </div>
    );
  },
);

KawaiiSelectButtonComponent.displayName = 'KawaiiSelectButton';

export const KawaiiSelectButton = memo(KawaiiSelectButtonComponent);
